export const lightPaletteText = {
  primary: "rgb(17, 24, 39)",
  secondary: "rgb(107, 114, 128)",
  disabled: "rgb(149, 156, 169)",
  white: "rgb(255, 255, 255)",
};

export const darkPaletteText = {
  primary: "rgb(255,255,255)",
  secondary: "rgb(148, 163, 184)",
  disabled: "rgb(156, 163, 175)",
  white: "rgb(255, 255, 255)",
};

const themesConfig = {
  default: {
    palette: {
      mode: "light",
      divider: "#e2e8f0",
      text: lightPaletteText,
      common: {
        black: "rgb(17, 24, 39)",
        white: "rgb(255, 255, 255)",
      },
      primary: {
        light: "#47526f",
        main: "#1d2a44",
        dark: "#111827",
        contrastText: darkPaletteText.primary,
      },
      secondary: {
        light: "#5765e4",
        main: "#013bb1",
        dark: "#001680",
        contrastText: darkPaletteText.primary,
      },
      info: {
        light: "#8a2fff",
        main: "#481FA7",
        dark: "#331676",
        contrastText: darkPaletteText.primary,
      },
      background: {
        paper: "#FFFFFF",
        default: "#f1f5f9",
        gui: "#111827",
        royalBlue: "#013BB1",
        electricCyan: "#80F2E7",
        imiPurple: "#481FA7",
        qaRed: "#FF5454",
        blueGrey: "#B8BABF",
        lightGrey: "#F1F5F9",
      },
      error: {
        light: "#ffcdd2",
        main: "#f44336",
        dark: "#b71c1c",
      },
    },
    status: {
      danger: "orange",
    },
  },
  defaultDark: {
    palette: {
      mode: "dark",
      divider: "rgba(241,245,249,.12)",
      text: darkPaletteText,
      common: {
        black: "rgb(17, 24, 39)",
        white: "rgb(255, 255, 255)",
      },
      primary: {
        light: "#64748b",
        main: "#334155",
        dark: "#0f172a",
        contrastText: darkPaletteText.primary,
      },
      secondary: {
        light: "#5765e4",
        main: "#013bb1",
        dark: "#001680",
        contrastText: darkPaletteText.primary,
      },
      background: {
        paper: "#1d2a44",
        default: "#111827",
        gui: "#111827",
      },
      error: {
        light: "#ffcdd2",
        main: "#f44336",
        dark: "#b71c1c",
      },
      status: {
        danger: "orange",
      },
    },
  },
};

export default themesConfig;
